(function () {

    'use strict';

    angular
        .module('committeeEditModule')
        .controller('CommitteeEditController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'committee'];

    function Controller($scope, topBarService, committee) {

        topBarService.setTitleAndIcon('Edit Committee', 'fa fa-users');

        $scope.committee = committee;

    }
})();